interface Props {
  band: { id: string; label: string };
  tone: 'danger' | 'warning' | 'success';
}

const toneClass: Record<Props['tone'], string> = {
  danger: 'bg-danger/10 text-danger',
  warning: 'bg-warning/10 text-warning',
  success: 'bg-success/10 text-success',
};

export default function BandLabel({ band, tone }: Props) {
  return (
    <span
      className={`inline-flex items-center rounded px-3 py-1 text-sm font-semibold ${toneClass[tone]}`}
    >
      {band.label}
    </span>
  );
}
